import React, { createContext, useContext, useEffect, useState } from "react";

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [authToken, setauthToken] = useState(null);
  const [isLogin, setIsLogin] = useState(!!localStorage.getItem("authToken"));

  useEffect(() => {
    const storedAuthToken = localStorage.getItem("authToken");

    if (storedAuthToken) {
      setauthToken(storedAuthToken);
      setIsLogin(true);
    } else {
      setIsLogin(false);
    }
  }, [authToken]);

  useEffect(() => {
    const handleStorageChange = (event) => {
      if (event.key === "authToken") {
        setauthToken(event.newValue);
      }
    };

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  const updateAuthToken = (token) => {
    setauthToken(token);
    if (token) {
      localStorage.setItem("authToken", token);
    } else {
      localStorage.removeItem("authToken");
    }
  };

  return (
    <AuthContext.Provider
      value={{
        authToken,
        updateAuthToken,
        isLogin,
        setIsLogin,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
